import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterArrangementTypeControlsLogic} from "./FilterArrangementTypeControls.logic";
import {
  SelectAndResetFilterControls
} from "../../../components/songs/songs-filters/select-and-reset-filter-controls/SelectAndResetFilterControls";

export const FilterArrangementTypeControls: VoidFunctionComponent = () => {
  const {handleResetOnClick} = useFilterArrangementTypeControlsLogic();
  return <SelectAndResetFilterControls onReset={handleResetOnClick} customLabel={`Reset type & feature filters`} ariaLabel={`Reset the arrangement type and feature filters to show all`} />;
}
